import * as actions from '@actions';
import { useQuery, useQueryClient } from '@tanstack/react-query';
import { useDispatch } from 'react-redux';
import { useCallback } from 'react';
import { useDefault } from '@hooks/useDefault';
import useIsRestricted from '@hooks/useIsRestricted';
import { Case } from 'vl-common/src/schemas/shared/case';

const queryKey = ['get-active-cases'] as const;

export default function useActiveCases() {
  const dispatch = useDispatch();
  const isRestricted = useIsRestricted();
  const queryClient = useQueryClient();

  const { data, isLoading } = useQuery<{ cases: Case[] }>({
    queryKey,
    queryFn: () => (isRestricted ? Promise.resolve({ cases: [] }) : dispatch(actions.getActiveCases()))
  });

  const cases = useDefault(data?.cases, []);

  return {
    isLoadingActiveCases: isLoading,
    activeCases: cases,
    updateActiveCases: useCallback(() => queryClient.invalidateQueries({ queryKey }), [queryClient])
  } as const;
}
